<template>
    <div class="grid-content">
        <div class="grid-item grid-item-quarter grid-item-break-half">
            <r-input
                label="Bump Amount"
                :left-label="offer.currency | currencySign"
                :value="offer.bumpAmount"
                @input="updateBumpAmount"
                :validate="validate.bumpAmount"/>
        </div>
        <div class="grid-item grid-item-quarter grid-item-break-half">
            <r-input
                label="Bonus Amount"
                :left-label="offer.currency | currencySign"
                :value="offer.bonusAmount"
                @input="updateBonusAmount"
                :validate="validate.bonusAmount"/>
        </div>
        <div class="grid-item grid-item-full">
            <choices-editor
                :choices="offer.choices"
                :validate="validate.choices"
                @input="updateChoices">
                <template #buttons="{doMerge}">
                    <v-popper>
                        <div slot="trigger">
                            <r-button
                                type="link"
                                v-popper-trigger
                                class="inline-s">Insert Placeholder</r-button>
                        </div>
                        <div class="popover" slot="content">
                            <div class="popover-control">
                                <div class="popover-content popover-menu">
                                    <a
                                        v-for="option in offerPlaceholders"
                                        class="popover-menu-item"
                                        href="#"
                                        @click.prevent="insertMergeTag(doMerge, option.value)">
                                        {{ option.label }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </v-popper>
                </template>
            </choices-editor>
        </div>
    </div>
</template>

<script>
    import {vSelect} from '@/components/form';
    import vPopper from '@/components/v-popper';
    import {BumpOfferModel} from '@/common/models/rules/actions/offer-purchase-bump-action-model';
    import ChoicesEditor from '@/modules/rules-engine/actions/display-other-choices/components/choices-editor';
    import {CURRENCIES_LIST} from '@/data/currencies';

    export default {
        name: 'offer-editor',
        components: {
            vSelect,
            vPopper,
            ChoicesEditor,
        },
        props: {
            index: Number,
            /**
             * @type {BumpOfferModel}
             */
            offer: BumpOfferModel,
            /**
             * Validation iteration for delegation to form components.
             */
            validationIteratee: Object,
        },
        computed: {
            validate() {
                // get the right index within the iteration
                return this.validationIteratee[this.index];
            },
            validationId() {
                return `offer-editor-${this.index}`;
            },
        },
        data() {
            return {
                currenciesList: CURRENCIES_LIST,
                offerPlaceholders: [
                    {
                        label: `Currency Sign`,
                        value: `{{currencySign}}`,
                    },
                    {
                        label: `Bump Amount`,
                        value: `{{bumpAmount}}`,
                    },
                    {
                        label: `Bonus Amount`,
                        value: `{{bonusAmount}}`,
                    },
                    {
                        label: `Accept Offer URL`,
                        value: `{{acceptOfferUrl}}`,
                    },
                    {
                        label: `Reject Offer URL`,
                        value: `{{rejectOfferUrl}}`,
                    },
                    {
                        label: `Return URL`,
                        value: `{{returnUrl}}`,
                    },
                ],
            };
        },
        methods: {
            triggerUpdate(offer) {
                this.$emit('input', {index: this.index, offer});
            },
            updateBumpAmount(bumpAmount) {
                this.triggerUpdate(this.offer.cloneSelf({bumpAmount}));
            },
            updateBonusAmount(bonusAmount) {
                this.triggerUpdate(this.offer.cloneSelf({bonusAmount}));
            },
            updateChoices(choices) {
                this.triggerUpdate(this.offer.cloneSelf({choices}));
            },
            insertMergeTag(mergeTagDelegate, content) {
                mergeTagDelegate({content});
            },
        },
    };
</script>

<style scoped>

</style>
